module.exports = __webpack_public_path__ + "img/folder@2x.73ef463f.svg";